<template>
  <div class="c-eventDetail">
    <PageTitle titleText="イベント予約" />

    <div v-if="!isReserved">
      <div
        class="c-eventDetail__card"
        v-for="(preview, index) in previews"
        :key="`preview_${index}`"
      >
        <div class="c-eventDetail__card__title">{{ preview.title }}</div>
        <div class="c-eventDetail__card__title-detail">
          下記日時をご確認の上、ご予定に合わせて以下ご選択をお願いします。
        </div>
        <div
          class="c-eventDetail__card__dateCard"
          v-for="(schedule, sindex) in preview.schedules"
          :key="`schedule_${index}_${sindex}`"
        >
          <div
            class="c-eventDetail__card__dateCard__title"
            v-if="reservedData.is_absent"
          >
            欠席
          </div>
          <div class="c-eventDetail__card__dateCard__title" v-else>
            {{ $date(schedule.date).tz().format("YYYY/MM/DD (ddd)") }}
          </div>
          <div class="c-eventDetail__card__dateCard__buttons">
            <div
              class="c-eventDetail__card__dateCard__buttonWrap"
              v-for="(koma, kindex) in schedule.komas"
              :key="`koma_${index}_${sindex}_${kindex}`"
              v-show="!koma.invisible"
            >
              <div
                class="c-eventDetail__card__dateCard__button"
                :class="{
                  disabled:
                    koma.capacity - koma.rooms.length == 0 ||
                    isExcludedRoom(koma),
                }"
                @click="
                  onReserve(
                    preview._id,
                    sindex,
                    kindex,
                    koma.capacity - koma.rooms.length
                  )
                "
              >
                <Button
                  text="欠席"
                  :disabled="koma.capacity - koma.rooms.length == 0"
                  v-if="koma.is_absent"
                ></Button>
                <Button
                  :text="`${koma.start}〜${koma.end}`"
                  :disabled="koma.capacity - koma.rooms.length == 0"
                  v-else
                ></Button>
              </div>
              <div
                v-if="preview.visibleRemaining"
                class="c-eventDetail__card__dateCard__buttonAsideText"
                :style="{ display: isExcludedRoom(koma) ? 'none' : 'block' }"
              >
                残り{{ koma.capacity - koma.rooms.length }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div @click="$router.go(-1)" class="c-eventDetail__returnButtonWrap">
        <el-button>戻る</el-button>
      </div>
    </div>

    <div v-else>
      <div class="c-eventDetail__card">
        <div class="c-eventDetail__card__title">{{ reservedData.title }}</div>
        <div class="c-eventDetail__card__title-detail">
          下記日時をご確認の上、ご予定に合わせて以下ご選択をお願いします。
        </div>
        <div
            class="c-eventDetail__card__dateCard__title"
            v-if="reservedData.is_absent"
          >
            欠席
          </div>
        <div class="c-eventDetail__card__dateCard__title" v-else>
          {{ $date(reservedData.date).tz().format("YYYY/MM/DD(ddd)") }}
        </div>
        <div v-if="reservedData.is_absent">
          <div class="c-eventDetail__card__reservedDate">{{ reservedData.absent_copy }}</div>
          <div class="c-eventDetail__card__reservedAsideText">

          </div>
        </div>
        <div v-else>
          <div class="c-eventDetail__card__reservedDate">
            {{ reservedData.start }}〜{{ reservedData.end }}
          </div>
          <div class="c-eventDetail__card__reservedAsideText">
            上記時間帯で予約済みです。
          </div>
        </div>

        <div>
          <!-- 下記divはコメントアウトで機能を仮置きしておるため、消さないように注意 -->
          <!-- <div v-if="canCancel">
            <div @click="onCancel" class="c-eventDetail__returnButton">
              <Button text="予約を取り消す"></Button>
            </div>
          </div> -->
          <div v-if="canCancel" class="c-eventDetail__card__reservedButtons">
            <div
              @click="onConfirm"
              class="c-eventDetail__returnButton"
              v-if="!reservedData.is_absent"
            >
              <Button text="この日時で申し込む"></Button>
            </div>
            <div @click="goRebooking" class="c-eventDetail__returnButton">
              <Button text="予約を変更する"></Button>
            </div>
            <div class="c-eventDetail__annotationText">
              ※期間中のご都合が合わない場合は<router-link
                class="c-eventDetail__annotationText__link"
                :to="{
                  name: 'in-contact',
                  params: { mc_code: mcCode },
                }"
                >【お問い合わせ】</router-link
              >よりご連絡をお願いいたします。
            </div>
          </div>
        </div>
      </div>
      <div @click="$router.go(-1)" class="c-eventDetail__returnButtonWrap">
        <el-button>戻る</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import PreviewSrevice from "../../../services/preview.service";
import PreviewReserveService from "../../../services/preview-reserve.service";
import PageTitle from "@/components/PageTitle.vue";
import Button from "@/components/Button.vue";

export default {
  components: {
    PageTitle,
    Button,
  },
  data() {
    return {
      isReserved: false,
      previews: [],
      reservedData: {},
      canCancel: true,
      previewReserve: {},
    };
  },

  async mounted() {
    await this.reloadData();
    await this.loadPreviewReserve();
  },
  watch: {
    $route(to, from) {
      console.log("watch", to, from);
      // this.reloadData();
    },
  },
  methods: {
    isExcludedRoom(koma) {
      if (!koma.excludedRooms) {
        return false;
      }
      const exRooms = koma.excludedRooms.split(",");
      return exRooms.includes(this.currentUser.roomNo);
    },
    // schedule.komasがからの場合previewsから削除する
    deleteEmptyKomas(previews) {
      return previews.filter((preview) => {
        preview.schedules = preview.schedules.filter(
          (schedule) => schedule.komas.length > 0
        );
        return preview.schedules.length > 0;
      });
    },
    async loadPreviewReserve() {
      const res = await PreviewReserveService.findv2({
        where: {
          mansion: this.currentUser.mansion.id,
          roomNo: this.currentUser.roomNo,
          preview: this.$route.params.previewid,
        },
      });
      console.log("res", res);
      if (res.data.length > 0) {
        this.previewReserve = res.data[0];
      }
    },
    async onConfirm() {
      console.log("onReserve", this.reservedData);
      // const res = await PreviewReserveService.findv2({
      //   where: {
      //     mansion: this.currentUser.mansion.id,
      //     roomNo: this.currentUser.roomNo,
      //     preview: this.$route.params.previewid,
      //   },
      // });
      // console.log("res", res);
      // const previewReserve = res.data[0];
      console.log("previewReserve", this.previewReserve);
      this.$router.push({
        name: "mc-event-reserve2",
        params: {
          previewid: this.$route.params.previewid,
          scheduleIndex: this.previewReserve.scheduleIndex,
          komaIndex: this.previewReserve.komaIndex,
          reserveid: this.reservedData._id,
        },
      });
      // console.log(
      //   `onReserve_${previewid}_${scheduleIndex},${komaIndex}_${nokori}`,
      // );
      // if (nokori > 0) {
      //   this.$router.push({
      //     name: "mc-event-reserve2",
      //     params: {
      //       previewid,
      //       scheduleIndex,
      //       komaIndex,
      //       reserveid: this.reservedData._id,
      //     },
      //   });
      // }
    },
    goRebooking() {
      console.log("goRebooking");
      this.$router.push({
        name: "mc-event-detail2",
        params: { previewid: this.$route.params.previewid },
      });
    },
    async reloadData() {
      console.log("reloadData");
      this.isExistReserve();
      const res = await PreviewSrevice.findWithReserve(
        this.$route.params.previewid
      );
      console.log(res.data);
      this.previews = res.data;
      this.previews = res.data;
      this.previews = this.deleteEmptyKomas(this.previews);
      var setTitle =
        this.previews[0].title + `予約 | ${this.currentUser.mansion.name}`;
      document.title = setTitle;

      console.log("this.reservedData", this.reservedData);
      console.log("this.previews", this.previews);

      // const dl = this.$date(this.reservedData.cancelDeadline).add(1, "days");
      // console.log(dd.format());

      this.canCancel = this.$date().isBefore(this.reservedData.cancelDeadline);
    },
    onUpdate() {},
    async onCancel() {
      if (confirm("予約を取り消しても良いですか？")) {
        console.log("onCancel");

        const res = await PreviewReserveService.remove(this.reservedData._id);
        console.log(res);
        this.$message.success("予約を取り消しました");
        this.reloadData();
      }
    },
    async isExistReserve() {
      const res = await PreviewReserveService.findv2({
        where: {
          mansion: this.currentUser.mansion.id,
          roomNo: this.currentUser.roomNo,
          preview: this.$route.params.previewid,
        },
        option: {
          populate: "preview",
        },
      });
      console.log("res", res);
      this.isReserved = res.data.length > 0;
      if (this.isReserved) {
        this.reservedData = {};
        const previewReserve = res.data[0];
        console.log("previewReserve", previewReserve);
        this.reservedData.cancelDay = previewReserve.preview.cancelDay;
        this.reservedData.cancelDeadline =
          previewReserve.preview.cancelDeadline;
        const preview = res.data[0].preview;
        this.reservedData.title = preview.title;
        this.reservedData.date =
          preview.schedules[previewReserve.scheduleIndex].date;
        this.reservedData.start =
          preview.schedules[previewReserve.scheduleIndex].komas[
            previewReserve.komaIndex
          ].start;
        this.reservedData.end =
          preview.schedules[previewReserve.scheduleIndex].komas[
            previewReserve.komaIndex
          ].end;
        this.reservedData._id = previewReserve._id;
        this.reservedData.is_absent =
          preview.schedules[previewReserve.scheduleIndex].komas[
            previewReserve.komaIndex
          ].is_absent;
        this.reservedData.absent_copy =
          preview.schedules[previewReserve.scheduleIndex].komas[
            previewReserve.komaIndex
          ].absent_copy;
      }
    },
    onReserve(previewid, scheduleIndex, komaIndex, nokori) {
      console.log(
        `onReserve_${previewid}_${scheduleIndex},${komaIndex}_${nokori}`
      );
      if (nokori > 0) {
        this.$router.push({
          name: "mc-event-reserve",
          params: { previewid, scheduleIndex, komaIndex },
        });
      }
    },
  },
};
</script>

<style>
.c-eventDetail__card__dateCard__button.disabled {
  pointer-events: none;
}

.c-eventDetail__card__dateCard__button.disabled > .c-button {
  background-color: #f0f0f0;
  color: #b0b0b0;
}
</style>
